import { ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
}

export const PageLayout = ({ children }: PageLayoutProps) => {
  return (
    <div className="flex relative flex-col flex-1 gap-4 lg:gap-8 p-4 xl:p-16 lg:py-16 lg:mt-0 w-screen lg:w-full mt-[96px] lg-px-8">
      {children}
    </div>
  );
};
